import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { Reveal } from "./Reveal";

const cities = ["Indore", "Jaipur", "Udaipur", "Surat", "Ahmedabad", "Bangalore", "Dahod"];

export default function Footprint() {
  return (
    <section id="footprint" data-testid="footprint-section" className="bg-heirloom-bone py-20 md:py-24">
      <div className="max-w-[1100px] mx-auto px-6 text-center">
        <Reveal>
          <span className="gold-rule overline text-heirloom-maroon">Our Footprint</span>
          <h2 className="font-display text-4xl md:text-5xl text-heirloom-obsidian mt-4">
            Celebrations <span className="text-heirloom-maroon italic">Across India</span>
          </h2>
          <p className="text-heirloom-obsidian/60 max-w-2xl mx-auto mt-4 leading-relaxed">
            We don&rsquo;t just create magic locally. From royal weddings to grand corporate expos, Arihant Events has
            planned and executed cross-state and cross-border celebrations spanning multiple cities.
          </p>
        </Reveal>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4 mt-10">
          {cities.map((c, i) => (
            <motion.span
              key={c}
              data-testid={`footprint-city-${i}`}
              initial={{ opacity: 0, y: 20, scale: 0.9 }}
              whileInView={{ opacity: 1, y: 0, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="group inline-flex items-center gap-2 bg-heirloom-cream border border-heirloom-line rounded-full px-6 py-3 text-sm md:text-base font-medium text-heirloom-obsidian hover:bg-heirloom-maroon hover:text-heirloom-bone hover:border-heirloom-maroon transition-colors duration-300"
            >
              <MapPin size={16} className="text-heirloom-maroon group-hover:text-heirloom-gold-light transition-colors" />
              {c}
            </motion.span>
          ))}
        </div>
      </div>
    </section>
  );
}
